var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.087,
    height: 22,
    viewBox: "0 0 23.087 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_45414",
    "data-name": "Path 45414",
    d: "M11.448,0a.876.876,0,0,1,.9.539c.977,1.993,1.964,3.982,2.94,5.976a.421.421,0,0,0,.373.268c2.206.31,4.41.636,6.615.955a.837.837,0,0,1,.484,1.5q-2.412,2.342-4.815,4.693a.338.338,0,0,0-.122.346c.39,2.236.767,4.475,1.152,6.712a.822.822,0,0,1-1.226.887q-2.981-1.569-5.961-3.139a.432.432,0,0,0-.464-.006c-1.976,1.047-3.958,2.084-5.937,3.127a.827.827,0,0,1-.952-.026.794.794,0,0,1-.305-.877c.038-.164.052-.333.081-.5.357-2.079.717-4.158,1.064-6.239a.405.405,0,0,0-.132-.288q-2.4-2.355-4.806-4.7A1.145,1.145,0,0,1,.04,8.8.774.774,0,0,1,.652,7.781c.756-.135,1.518-.236,2.278-.346,1.537-.224,3.075-.441,4.61-.675a.441.441,0,0,0,.25-.234Q9.066,3.965,10.327,1.4c.153-.31.307-.62.458-.931A.753.753,0,0,1,11.448,0",
    transform: "translate(0 -0.001)",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlack);
export default __webpack_public_path__ + "static/media/star_black.2802732a1ad3728d3efc97bb3e39096f.svg";
export { ForwardRef as ReactComponent };